import React from 'react'

const UpdateRequired: React.FC<{ store_url: string, latest_version: string }> = ({ store_url, latest_version }) => {
    return (
        <>
            <div className="d-flex flex-column gap-075">
                <h4 className="new-slide-up-modal-heading mt-2 mb-0">Update Available</h4>
            </div>
            <div className="divider my-2"></div>
            <span>A newer version of this app is available to download. Please update to the latest version.</span>
            <div className="divider my-2"></div>
            <div className="campaign-apply-ig-connect-benefit-actions pb-5">
                <a href={store_url} className='new-ui-btn' target="_blank" rel="noopener noreferrer">Update Now</a>
            </div>
        </>

    )
}

export default UpdateRequired
